const config = function () {
  return {
    baseURL: 'https://hm.tgapp.live/',
    headers: {
      Accept: 'application/json',
    },
  };
};

export default config;
